import React from 'react';
import NavPane from '../../components/NavPane';
import { templates } from './queries';

const TemplatesMenu = () => (
  <NavPane query={templates} dataRoot='templates' urlRoot='templates' />
);

export default TemplatesMenu
